<template>
  <div class="soar-container flex flex-col gap-y-3">
    <div class="print:hidden flex flex-col gap-y-4">
      <div v-if="!isLoading" class="w-full flex items-center text-sm md:text-base overflow-x-auto">
        <template :key="key" v-for="(route, key) in tabRoutes.filter((r) => r.show)">
          <router-link
            :to="route.to"
            :class="[
              matchedRoute.includes(route.to.name) ? 'text-primary border-b-2 border-primary' : ''
            ]"
            class="flex-none py-0.5 md:py-2 px-1.5 md:px-3 hover:bg-brand-gray-150"
          >
            {{ $t(route.label) }}
          </router-link>
          <div class="last:hidden w-2 h-5 mb-1 border-e border-brand-gray-600"></div>
        </template>
      </div>
    </div>

    <div class="pt-4">
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup>
import client_config from '@/assets/json/client_config.json'
import axiosInstance from '@/services'
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

const isLoading = ref(true)
const route = useRoute()
const matchedRoute = computed(() => route.matched.map((m) => m.name))

const { enableDelegateCardEstabBoxesOnEchannels } = client_config

const tabRoutes = ref()

onMounted(async () => {
  const tourismVisaEligibility = await axiosInstance.get(
    '/api/establishment/tourismVisaDeposit/isEstablishmentEligibleForTouristVisaDeposit'
  )

  const { isEligible, hasDefaultWallet } = tourismVisaEligibility

  tabRoutes.value = [
    {
      to: { name: 'EstProfileLanding' },
      label: 'establishmentMainInformation',
      show: true
    },
    {
      to: { name: 'EstProfileCard' },
      label: 'establishmentCard',
      show: true
    },
    {
      to: { name: 'EstProfileDelegateCard' },
      label: 'violatedDelegateCard',
      show: true
    },
    {
      to: { name: 'EstProfileGroupInsuranceQuota' },
      label: 'groupInsuranceQuota',
      show: true
    },
    {
      to: { name: 'EstProfileBoxDetails' },
      label: 'boxDetails',
      show: enableDelegateCardEstabBoxesOnEchannels
    },
    {
      to: { name: 'EstProfileValidationGatewayDetails' },
      label: 'validationGatewayDetails',
      show: true
    },
    {
      to: { name: 'EstProfileTouristWallet' },
      label: 'establishmentTouristWallet',
      show: isEligible && hasDefaultWallet
    },
    {
      to: { name: 'EstProfileTouristVisaDepositSelect' },
      label: 'TouristVisaDepositSelect',
      show: isEligible && !hasDefaultWallet
    }
  ]

  isLoading.value = false
})
</script>

<style lang="scss" scoped></style>
